'use client';

import ExploreNavigationBase from '@/components/ExploreNavigationBase/ExploreNavigationBase';
import useStreetAddressSelect from '@/hooks/useStreetAddressSelect';
import { useAppSelector } from '@/utils/redux';

const ExploreNavigation = () => {
  const locationResult = useAppSelector(state => state.exploreService.locationResult);
  const handleAddressSelect = useStreetAddressSelect();

  return <ExploreNavigationBase searchOnAddressSelect={handleAddressSelect} searchValue={locationResult?.name} />;
};

export default ExploreNavigation;
